const pushNotificationsSchedule = {
  'push-notifications-schedule-breadcrumbs': 'Schedule',
  'push-notifications-schedule-filter-title': 'Schedule filter',
  'push-notifications-schedule-time-outdated': 'The selected time is outdated',
  'push-notifications-schedule-id': 'Schedule ID',
};

export default pushNotificationsSchedule;
